import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpandChartComponent } from './expand-chart.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ChartModule } from 'angular-highcharts';



@NgModule({
  declarations: [
    ExpandChartComponent
  ],
  imports: [
    CommonModule,
     MaterialModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    ChartModule
  ],
   exports:[
    ExpandChartComponent
  ]
})
export class ExpandChartModule { }
 